<template>
  <form name="form" v-on:submit.prevent="submit" v-on:change="changeHandler">
    <fieldset
      :disabled="readonly"
      style="border:0;padding:0;margin:0;min-width:0;"
    >
      <div class="card-body">
        <div class="text-right" v-if="!readonly">
          <form-button :indicator="form.processing()" v-on:clicked="submit">
            Save
          </form-button>
        </div>
        <div class="clearfix"></div>
        <hr />

        <company-select
          id="diminution-company-select"
          heading="Engineer Details"
          label="Enter the details of the engineer"
          :types="companyTypes"
          :company="getCompany"
          ref="diminutionCompany"
        ></company-select>
      </div>
      <div class="card-footer text-right" v-if="!readonly">
        <form-button :indicator="form.processing()" v-on:clicked="submit">
          Save
        </form-button>
      </div>
    </fieldset>
  </form>
</template>

<script>
import Company from './../Shared/Company';

export default {
  props: {
    incident: {
      type: String,
      required: true
    },
    selectedService: {
      type: Object,
      required: false,
      default: null
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  components: {
    'company-select': Company
  },
  data() {
    return {
      form: new window.Form(
        {
          service_id: null,
          engineers_name: null,
          engineers_phone: null,
          engineers_email: null,
          company_id: null,
          company_name: null,
          company_email_address: null,
          company_telephone_number: null,
          company_address_line_one: null,
          company_address_line_two: null,
          company_city: null,
          company_postcode: null
        },
        true
      ),
      diminution_exists: false,
      data_entered: false,
      companyTypes: []
    };
  },
  mounted() {
    this.mount();
  },
  computed: {
    diminution() {
      return this.$store.getters['Incident/diminution'];
    },
    getCompany() {
      return {
        company_id: this.form.company_id,
        name: this.form.company_name,
        email_address: this.form.company_email_address,
        telephone_number: this.form.company_telephone_number,
        address_line_one: this.form.company_address_line_one,
        address_line_two: this.form.company_address_line_two,
        city: this.form.company_city,
        postcode: this.form.company_postcode
      };
    }
  },
  methods: {
    mount() {
      if (this.diminution && this.diminution.identifier) {
        this.setDiminution(this.diminution);
      }
    },
    setDiminution(diminution) {
      this.diminution_exists = true;
      this.form.engineers_name = diminution.engineers_name;
      this.form.engineers_phone = diminution.engineers_phone;
      this.form.engineers_email = diminution.engineers_email;
      this.form.company_id = diminution.company_id;
      this.form.company_name = diminution.company_name;
      this.form.company_email_address = diminution.company_email_address;
      this.form.company_telephone_number = diminution.company_telephone_number;
      this.form.company_address_line_one = diminution.company_address_line_one;
      this.form.company_address_line_two = diminution.company_address_line_two;
      this.form.company_city = diminution.company_city;
      this.form.company_postcode = diminution.company_postcode;
    },
    setCompany(company) {
      this.form.company_id = company.company_id;
      this.form.company_name = company.name;
      this.form.company_email_address = company.email_address;
      this.form.company_telephone_number = company.telephone_number;
      this.form.company_address_line_one = company.address_line_one;
      this.form.company_address_line_two = company.address_line_two;
      this.form.company_city = company.city;
      this.form.company_postcode = company.postcode;
    },
    changeHandler() {
      if (!this.data_entered) {
        this.data_entered = true;
      }
      this.$emit('unsaved-data', this.data_entered);
    },
    submit() {
      if (this.readonly) return;
      this.setCompany(this.$refs.diminutionCompany.form);
      if (this.selectedService) {
        this.form.service_id = this.selectedService.id;
      }
      if (this.diminution_exists) {
        this.makeRequest('put');
        this.data_entered = false;
        this.$emit('unsaved-data', this.data_entered);
        return;
      }

      this.makeRequest('post');
      this.data_entered = false;
      this.$emit('unsaved-data', this.data_entered);
    },
    makeRequest(method) {
      this.form[method](`/incidents/${this.incident}/services/diminution`)
        .then(response => {
          if (!this.diminution_exists) {
            this.diminution_exists = true;
          }
          this.$store.commit('Incident/setDiminution', response);
          this.setDiminution(response);
          window.toastify.success(
            'Saved',
            'The diminution was saved successfully!'
          );
        })
        .catch(error => {
          window.toastify.error(
            'Error',
            "We couldn't save the diminution - please try again."
          );
        });
    }
  }
};
</script>
